import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';

export const VIEW_DOCUMENTS_HEADER = 'View Documents';

export const DOWNLOAD_ERROR_MESSAGE = "Couldn't download bundle";

export const PRINT_ERROR_MESSAGE = 'Could not print document';

export const DOCUMENT_VIEW_ID = 'signature';

const PREVIEW_CONFLICT_MESSAGE =
  'This package is no longer being signed. Its status has been updated.';

const PREVIEW_SIGNER_MESSAGE =
  "You can't preview this copy because you are a signer on this package.";

export const PREVIEW_ERROR_MESSAGE = 'Could not load the borrower copy preview';

export const PREVIEW_ERROR_MESSAGE_BY_STATUS = {
  [HTTP_RESPONSE_STATUS_CODES.CONFLICT]: PREVIEW_CONFLICT_MESSAGE,
  [HTTP_RESPONSE_STATUS_CODES.FORBIDDEN]: PREVIEW_SIGNER_MESSAGE,
};
